import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { ServicesSection } from "@/components/ServicesSection";
import { CeramicSection } from "@/components/CeramicSection";
import { MaxMatsSection } from "@/components/MaxMatsSection";
import { BookingSection } from "@/components/BookingSection";
import { MapSection } from "@/components/MapSection";
import { Footer } from "@/components/Footer";

export default function Landing() {
    return (
        <div data-testid="landing-page">
            <Nav />
            <Hero />
            <Marquee />
            <ServicesSection />
            <CeramicSection />
            <MaxMatsSection />
            <BookingSection />
            <MapSection />
            <Footer />
        </div>
    );
}
